import { gql } from '@apollo/client';
export const COMPETENCE_ORDER_SAVE_SUBSCRIPTION = gql`
  subscription Subscription {
    competenceOrderUpdated {
      competenceOrderId
    }
  }
`;

export const COMPETENCE_ORDER_DELETE_SUBSCRIPTION = gql`
  subscription competenceOrderDeleted {
    competenceOrderDeleted {
      competenceOrderId
    }
  }
`;

export const COMPETENCE_ORDER_RULE_DELETE_SUBSCRIPTION = gql`
  subscription competenceOrderRuleDeleted {
    competenceOrderRuleDeleted {
      competenceOrderRuleId
    }
  }
`;
